import { gql } from '@apollo/client'

export const APPROVE_CLEARANCE_STATUS = gql`
  mutation ApproveClearanceStatus($inputData: ApproveClearanceStatusInput!) {
    approveClearanceStatus(inputData: $inputData) {
      id
    }
  }
`
